import { SessionStore } from '../../constants';
import { TaskItem } from '../../taskList/interfaces';
import { TaskItemStatus } from '../../taskList/constants';
import { getStore } from '../../store';
import { isSimplifiedFlow } from '../../workflowConfigurablePages/utils/simplifiedFormStatus';

export const checkFormsCompleted = (items: TaskItem[]): TaskItem[] => {
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);
  return items.map((item) => {
    if (item.completionIndicator && formStatus && formStatus[item.completionIndicator])
      item.status = TaskItemStatus.COMPLETED;
    return { ...item };
  });
};

export const formsIndicators = (): {
  [index: string]: boolean | undefined;
} => {
  const companySettings = getStore()?.state?.companySettings;

  const indicatorObj: { [index: string]: boolean | undefined } = {
    appFormIndicator: companySettings?.showAppform,
    eeoIndicator: companySettings?.showEeo,
    ofccpIndicator: companySettings?.enableOfccp,
    researchQuestionsIndicator: companySettings?.allowCEBDemographyResearch,
  };

  return indicatorObj;
};

export const allFormsCompleted = (): boolean => {
  const companySettings = getStore()?.state?.companySettings;
  const formStatusSession = sessionStorage.getItem(SessionStore.formStatus);
  const formStatus = formStatusSession && JSON.parse(formStatusSession);

  let formsCompleted = true;
  if (formStatus && companySettings) {
    if (isSimplifiedFlow()) return formsCompleted;
    else if (
      (!formStatus.applicationFormSubmitted && companySettings.showAppform) ||
      (!formStatus.ofccpSubmitted && companySettings.enableOfccp) ||
      (!formStatus.eeoSubmitted && companySettings.showEeo) ||
      (!formStatus.researchQuestionSubmitted && companySettings.allowCEBDemographyResearch)
    )
      formsCompleted = false;
  }
  return formsCompleted;
};
